.week-selector {
  position: relative;
}

.week-selector-button {
  align-items: center;
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-700);
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: inherit;
  height: 2.75rem;
  justify-content: space-between;
  min-width: 8rem;
  padding: 0 0.75rem 0 1rem;
}

.week-selector-button:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}

.week-selector-option-container {
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-400);
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  inset: 100% auto auto 0;
  padding: 1.5rem;
  position: absolute;
  width: max-content;
  z-index: 10;
}

.week-selector-option-header {
  color: var(--color-uva-black);
  font-family: inherit;
  font-size: var(--font-size-default);
  font-weight: var(--semibold);
  margin: 0;
}

.week-selector-option-table {
  display: flex;
  gap: 1.5rem;
}

.week-selector-option-table-labels,
.week-selector-option-week-grid {
  display: flex;
  flex-direction: column;
  font-family: inherit;
  gap: 0.5rem;
  min-width: max-content;
  padding: 0.5rem 0;
}

.week-selector-option-table-label {
  color: var(--color-uva-black);
  font-weight: var(--semibold);
  line-height: 2.25rem;
}

.week-selector-option-week-grid {
  border: 1px solid var(--color-grey-700);
  border-radius: 0.5rem;
  max-width: max-content;
  padding: 0.5rem;
  width: 100%;
}

.week-selector-option-week-row {
  display: flex;
  gap: 0.25rem;
}

.week-selector-option-week {
  align-items: center;
  background-color: var(--color-uva-white);
  border: none;
  border-radius: 0.25rem;
  color: var(--color-uva-black);
  cursor: pointer;
  display: flex;
  height: 2.25rem;
  justify-content: center;
  width: 2.25rem;
}

.week-selector-option-week:disabled {
  background-color: var(--color-grey-400);
  color: var(--color-grey-700);
}

.week-selector-option-week:disabled:active {
  background-color: var(--color-grey-500);
  color: var(--color-grey-00);
  font-weight: var(--semibold);
}

.week-selector-option-week:disabled:hover {
  cursor: not-allowed;
}

.week-selector-option-week:hover {
  background-color: var(--color-grey-300);
}

.week-selector-option-week--selected,
.week-selector-option-week--selected:hover {
  background-color: var(--color-navy-600);
  color: var(--color-uva-white);
}

.week-selector-option-week:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: 0.125rem;
}
